"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentDiv = exports.ContainerDiv = void 0;
var styled_components_1 = require("styled-components");
var Theme_1 = require("../../../Theme");
var buildConditionalStyle = function (show, isFullSize, size) {
    if (!show) {
        return { opacity: 0 };
    }
    if (isFullSize) {
        return { height: "100%" };
    }
    return {
        borderBottomLeftRadius: size * 2 + "px",
        borderBottomRightRadius: size * 2 + "px",
        height: "50%",
        opacity: 0.9,
    };
};
exports.ContainerDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    font-family: ", ";\n    ", ";\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    font-size: 10px !important;\n    font-weight: bold;\n    cursor: pointer;\n"], ["\n    ", "\n    font-family: ", ";\n    ", ";\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    font-size: 10px !important;\n    font-weight: bold;\n    cursor: pointer;\n"])), Theme_1.Color.Blue.Dark, Theme_1.FontFamily, function (props) { return buildConditionalStyle(props.Show, props.IsFullSize, props.Size); });
exports.ContentDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: grid;\n    justify-items: center;\n    align-content: ", ";\n    height: ", ";\n"], ["\n    display: grid;\n    justify-items: center;\n    align-content: ", ";\n    height: ", ";\n"])), function (props) { return props.IsFullSize || !props.IsLargest ? "center" : "start"; }, function (props) { return props.IsFullSize || props.IsLargest ? "100%" : "75%"; });
var templateObject_1, templateObject_2;
